"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _lodash = require("lodash");
var _src = require("@seedlang/utils/src");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ALERT_MESSAGES = {
  deleted: 'Your reviews were successfully deleted.',
  retired: 'Your reviews were retired and will not be due for review anymore.',
  restored: 'Your reviews were restored and will due for review again in the future.',
  reset: 'Your reviews were reset and are due now.'
};
var BulkEditReviewsWrapper = function BulkEditReviewsWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _initializerDefineProperty(_this, "showSpinner", _descriptor, _this);
      _initializerDefineProperty(_this, "alertMessage", _descriptor2, _this);
      _initializerDefineProperty(_this, "showDeleteConfirmationModal", _descriptor3, _this);
      _initializerDefineProperty(_this, "showResetConfirmationModal", _descriptor4, _this);
      _initializerDefineProperty(_this, "showDeckSelector", _descriptor5, _this);
      _initializerDefineProperty(_this, "showCardTypeSelector", _descriptor6, _this);
      _this.toggleDeleteModal = function () {
        _this.showDeleteConfirmationModal = !_this.showDeleteConfirmationModal;
      };
      _this.toggleResetModal = function () {
        _this.showResetConfirmationModal = !_this.showResetConfirmationModal;
      };
      _this.destroyReviews = function () {
        _this.showSpinner = true;
        _this.showDeleteConfirmationModal = false;
        _state.DeckUI.cardStore.batchDestroy({
          data: {
            cardIds: _this.props.selectedReviewIds
          }
        }, _this.afterDestroyReviews);
      };
      _this.finalizeBulkEditAction = function () {
        _this.showDeckSelector = false;
        _this.showCardTypeSelector = false;
        _this.props.resetSelectedCards();
      };
      _this.dismissBulkEdit = function () {
        _this.showDeleteConfirmationModal = false;
        _this.showResetConfirmationModal = false;
        _this.finalizeBulkEditAction();
      };
      _this.afterDestroyReviews = function () {
        _this.showSpinner = false;
        _this.alertMessage = ALERT_MESSAGES['deleted'];
        (0, _lodash.remove)(_state.DeckUI.cardStore.indexData, function (item) {
          return _this.props.selectedReviewIds.includes(item.id);
        });
        _this.finalizeBulkEditAction();
        setTimeout(function () {
          _this.alertMessage = null;
        }, 3000);
        _this.props.afterChange();
      };
      _this.resetReviews = function () {
        _this.showResetConfirmationModal = false;
        if (_this.selectedCards.length === 0) {
          return;
        }
        _this.selectedCards.forEach(function (card) {
          return card.onResetReview();
        });
        _state.DeckUI.cardStore.batchReset({
          data: {
            cardIds: _this.props.selectedReviewIds
          }
        }, _this.afterResetReviews);
      };
      _this.retireReviews = function () {
        var _this$selectedCards;
        var retired = _this.nonRetiredSelectedCards.length !== 0;
        (_this$selectedCards = _this.selectedCards) === null || _this$selectedCards === void 0 || _this$selectedCards.forEach(function (item) {
          return item.set('retired', retired);
        });
        _state.DeckUI.cardStore.batchUpdate({
          data: {
            cardIds: _this.props.selectedReviewIds,
            retired: retired
          }
        }, function () {
          return _this.afterRetireReviews(retired);
        });
      };
      _this.updateSelectedCardsDeck = function (deckId) {
        var _this$selectedCards2;
        if (!_state.AppUI.layout.isNative) {
          _this.showDeckSelector = false;
        }
        (_this$selectedCards2 = _this.selectedCards) === null || _this$selectedCards2 === void 0 || _this$selectedCards2.forEach(function (item) {
          return item.set('deckId', deckId);
        });
        _state.DeckUI.cardStore.batchUpdate({
          data: {
            cardIds: _this.props.selectedReviewIds,
            deckId: deckId
          }
        }, function () {
          return _this.afterUpdateDeck(deckId);
        });
      };
      _this.updateSelectedCardsType = function (cardTypeId) {
        var _this$selectedCards3;
        if (!_state.AppUI.layout.isNative) {
          _this.showCardTypeSelector = false;
        }
        (_this$selectedCards3 = _this.selectedCards) === null || _this$selectedCards3 === void 0 || _this$selectedCards3.forEach(function (item) {
          return item.set('cardTypeId', cardTypeId);
        });
        _state.DeckUI.cardStore.batchUpdate({
          data: {
            cardIds: _this.props.selectedReviewIds,
            cardTypeId: cardTypeId
          }
        }, _this.afterUpdateCardTypes.bind(_this, cardTypeId));
      };
      _this.afterUpdateWithFilters = function () {
        _this.showSpinner = false;
        _this.finalizeBulkEditAction();
      };
      _this.afterUpdateCardTypes = function (cardTypeId) {
        if ((0, _src.isPresent)(_state.AppUI.cardStore.getFilterValue('card_type_id')) && !_state.AppUI.cardStore.getFilterValue('card_type_id').includes(cardTypeId)) {
          _this.showSpinner = true;
          _this.props.afterChange(_this.afterUpdateWithFilters);
        } else {
          _this.finalizeBulkEditAction();
        }
      };
      _this.afterUpdateDeck = function (deckId) {
        var _this$props$reviewDec, _AppUI$reviewDeckStor;
        var optionPair = (_this$props$reviewDec = _this.props.reviewDeckOptions) === null || _this$props$reviewDec === void 0 ? void 0 : _this$props$reviewDec.find(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 1),
            id = _ref2[0];
          return id == deckId;
        });
        var deckName = (0, _src.isPresent)(optionPair === null || optionPair === void 0 ? void 0 : optionPair[1]) ? optionPair[1] : ((_AppUI$reviewDeckStor = _state.AppUI.reviewDeckStore.indexData.find(function (item) {
          return item.id == deckId;
        })) === null || _AppUI$reviewDeckStor === void 0 ? void 0 : _AppUI$reviewDeckStor.name) || 'deck';
        _this.alertMessage = "Your reviews were moved to \"".concat(deckName, "\".");
        setTimeout(function () {
          _this.alertMessage = null;
        }, 4000);
        if ((0, _src.isPresent)(_state.AppUI.cardStore.getFilterValue('deck_id')) && !_state.AppUI.cardStore.getFilterValue('deck_id').includes(deckId)) {
          _this.showSpinner = true;
          _this.props.afterChange(_this.afterUpdateWithFilters);
        } else {
          _this.finalizeBulkEditAction();
        }
      };
      _this.afterRetireReviews = function (retired) {
        _this.alertMessage = ALERT_MESSAGES[retired ? 'retired' : 'restored'];
        setTimeout(function () {
          _this.alertMessage = null;
        }, 4000);
        _this.finalizeBulkEditAction();
      };
      _this.afterResetReviews = function () {
        _this.alertMessage = ALERT_MESSAGES['reset'];
        setTimeout(function () {
          _this.alertMessage = null;
        }, 4000);
        if ((0, _src.isPresent)(_state.AppUI.cardStore.getFilterValue('due')) || _state.AppUI.cardStore.sort.includes('review_after')) {
          _this.showSpinner = true;
          _this.props.afterChange(_this.afterUpdateWithFilters);
        } else {
          _this.finalizeBulkEditAction();
        }
      };
      _this.toggleShowDeckSelector = function () {
        _this.showDeckSelector = !_this.showDeckSelector;
        _this.showCardTypeSelector = false;
      };
      _this.toggleShowCardTypeSelector = function () {
        _this.showCardTypeSelector = !_this.showCardTypeSelector;
        _this.showDeckSelector = false;
      };
      _this.handleOutsideClick = function (event) {
        if (_state.AppUI.layout.isNative) return;
        var selector = document.querySelector('.selector');
        if (selector && !selector.contains(event.target)) {
          _this.showDeckSelector = false;
          _this.showCardTypeSelector = false;
        }
      };
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "nonRetiredSelectedCards",
      get: function get() {
        var _this$selectedCards4;
        return (_this$selectedCards4 = this.selectedCards) === null || _this$selectedCards4 === void 0 ? void 0 : _this$selectedCards4.filter(function (item) {
          return !item.retired;
        });
      }
    }, {
      key: "selectedCards",
      get: function get() {
        var _this2 = this;
        return _state.DeckUI.cardStore.indexData.filter(function (item) {
          return _this2.props.selectedReviewIds.includes(item.id);
        });
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          showSpinner: this.showSpinner,
          destroyReviews: this.destroyReviews,
          retireReviews: this.retireReviews,
          nonRetiredSelectedCards: this.nonRetiredSelectedCards,
          selectedCards: this.selectedCards,
          updateSelectedCardsDeck: this.updateSelectedCardsDeck,
          updateSelectedCardsType: this.updateSelectedCardsType,
          alertMessage: this.alertMessage,
          showDeckSelector: this.showDeckSelector,
          showCardTypeSelector: this.showCardTypeSelector,
          toggleShowDeckSelector: this.toggleShowDeckSelector,
          toggleShowCardTypeSelector: this.toggleShowCardTypeSelector,
          showDeleteConfirmationModal: this.showDeleteConfirmationModal,
          toggleDeleteModal: this.toggleDeleteModal,
          showResetConfirmationModal: this.showResetConfirmationModal,
          toggleResetModal: this.toggleResetModal,
          handleOutsideClick: this.handleOutsideClick,
          resetReviews: this.resetReviews,
          dismissBulkEdit: this.dismissBulkEdit
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "showSpinner", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "alertMessage", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "showDeleteConfirmationModal", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "showResetConfirmationModal", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "showDeckSelector", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "showCardTypeSelector", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "nonRetiredSelectedCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "nonRetiredSelectedCards"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectedCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedCards"), _class2.prototype), _class2)) || _class;
};
BulkEditReviewsWrapper.displayName = 'BulkEditReviewsWrapper';
var _default = exports["default"] = BulkEditReviewsWrapper;